export class Produktlinie {

    produktlinie: string;
    percent: number;
    start: number;
    next: number;
    step: number;
    maximalHoehe: number;
    nextProduktlinien: string[];

}
